import React from 'react';
import './App.css';
import HEPTDashboard from './components/HEPTDashboard';

// Import your actual tab components here
// import AwarenessKnowledgeTab from './components/AwarenessKnowledgeTab';
// import PersonalHealthTab from './components/PersonalHealthTab'; 
// import BehavioralIntentTab from './components/BehavioralIntentTab';

function App() {
  return (
    <div className="App">
      <HEPTDashboard />
    </div>
  );
}

export default App;
